import styled from 'styled-components';

const NotificationText = styled.div<{ $color: 'white' | 'black' }>`
	font-family: GT Walsheim Pro;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	user-select: none;
	pointer-events: none;
	color: ${(props) => props.$color};
`;

export { NotificationText };
